<div>
    <div class="mb-3">
        <h1>Please enter more information about this case</h1>
        <div class="mt-1">Case title: {{ caseModel.title }}</div>
    </div>

    <v-form ref="form" @submit.prevent="submit">
        <p class="mb-2">Please enter the following information:</p>
        <div>
            <label class="d-block mb-2">Solution (in English) *</label>
            <v-textarea
                variant="outlined"
                :rules="[(v) => !!v || 'Solution is required']"
                :loading="loading"
                placeholder="Please enter the solution to this case in English"
                v-model="solution"></v-textarea>
        </div>
        <div class="d-flex justify-end">
            <BaseButton :width="200" submit :disabled="loading">
                Submit
            </BaseButton>
        </div>
    </v-form>
</div>